// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__24TqW","description":"PatientConsentPreview_description__2_9kX"};